import Icon from './src/icon'

export default Icon
